// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{margin:0}body input,body div,body p,body textarea{text-align:start;unicode-bidi:plaintext}\n", ""]);
// Exports
module.exports = exports;
